import React, { useCallback } from "react";
import DynamicLinesDialog from "../../../components/DynamicLinesDialog";
import { fetchDataEngine, graphqlQuery } from "../../../data/Axios/DynamicService";
import { accountsmanagement } from "../../../config";
import { allAccountSubCategories, allTaxRates } from "../../../data/Axios/queries";

const base_url = accountsmanagement.uri;

export const ProformaNoteDetailDialog = ({ open, onClose, proformaData, refetchData }) => {
    const loadAccountSubCategories = useCallback(async () => {
        const data = await graphqlQuery(allAccountSubCategories, base_url);
        // Filter to match FeeNote behaviour (IDs 34 and 37)
        return (data || []).filter((subCat) => [34, 37].includes(subCat.id));
    }, []);

    const loadTaxRates = useCallback(async () => {
        const data = await graphqlQuery(allTaxRates, base_url);
        // Filter tax rates to taxTypeId === 1 (as FeeNote does)
        return (data || []).filter((tax) => tax.taxTypeId === 1);
    }, []);

    const calculateVatAmount = useCallback((formValues, fieldOptions) => {
        const { amount, vatId } = formValues;
        const taxRates = fieldOptions.vatId || [];
        if (!amount || !vatId) return { vatAmount: 0 };
        const selectedTax = taxRates.find((tax) => tax.id === parseInt(vatId));
        if (!selectedTax) return { vatAmount: 0 };
        const vatAmount = (parseFloat(amount) * (selectedTax.rate / 100)).toFixed(2);
        return { vatAmount: parseFloat(vatAmount) };
    }, []);

    const formFields = [
        { name: "description", label: "Description", type: "text", required: true },
        { name: "accountSubCategoryId", label: "Account Subcategory", type: "select", required: true },
        { name: "amount", label: "Amount", type: "number", required: true, onChangeEffect: "calculateVat" },
        { name: "vatId", label: "VAT", type: "select", required: true, onChangeEffect: "calculateVat" },
        { name: "vatAmount", label: "VAT Amount", type: "number", disabled: true },
    ];

    const columns = [
        { field: "id", headerName: "ID", flex: 0.5 },
        { field: "description", headerName: "Description", flex: 1.5 },
        { field: "accountSubCategoryName", headerName: "Account Subcategory", flex: 1 },
        { field: "amount", headerName: "Amount", flex: 0.8, format: "currency" },
        { field: "vatAmount", headerName: "VAT Amount", flex: 0.8, format: "currency" },
    ];

    const queryConfig = {
        name: "proformaFeeNotesQuotationsLinesByProformaId",
        modelName: "proformaFeeNotesQuotationsLines",
        inputField: "proformaFeeNoteQuotationId",
        fields: [
            "id",
            "proformaFeeNoteQuotationId",
            "description",
            "accountSubCategoryId",
            "accountSubCategoryName",
            "amount",
            "vatId",
            "vatAmount",
            "isActive",
        ],
    };

    const mutationConfig = {
        create: "createProformaFeeNotesQuotationsLines",
        update: "updateProformaFeeNotesQuotationsLines",
        modelName: "proformaFeeNotesQuotationsLines",
        updateModelName: "proformaFeeNotesQuotationsLines",
    };

    return (
        <DynamicLinesDialog
            open={open}
            onClose={onClose}
            title={`Proforma Lines – ${proformaData?.documentNumber || ""}`}
            parentData={proformaData}
            parentIdField="proformaFeeNoteQuotationId"
            baseUrl={base_url}
            queryConfig={queryConfig}
            mutationConfig={mutationConfig}
            refetchData={refetchData}
            formFields={formFields}
            columns={columns}
            optionsLoaders={{ accountSubCategoryId: loadAccountSubCategories, vatId: loadTaxRates }}
            customCalculations={{ calculateVat: calculateVatAmount }}
            additionalMutationData={{ isActive: 1 }}
            readOnlyInfo={{ fields: [{ label: "Proforma Note", getValue: () => proformaData?.documentNumber || "N/A" }] }}
            canAdd={true}
        />
    );
};

export default ProformaNoteDetailDialog;
